module.exports = __webpack_public_path__ + "img/logo.e3bbb0dd.png";